"use client"

import { CSSProperties, useEffect, useState } from "react"

interface Props {
    src: string | undefined
    alt: string
    /** Imagem caso houver erro em src. */
    fallbackSrc?: string
    className?: string
    style?: CSSProperties | undefined
    isMerchantImage?: boolean
    setHasError?(e: boolean): void
}

/** Adiciona uma imagem padrão caso haja um erro ao carregar a imagem desejada. */
const ImageFallback: React.FC<Props> = ({
    src,
    alt,
    fallbackSrc,
    className,
    isMerchantImage,
    style,
}) => {
    const defaultPath = 'https://files.menudino.com'
    const productNotFoundImage = `${defaultPath}/padroes/product_not_found.jpg`
    const merchantDefaultImage = `${defaultPath}/padroes/logo-cardapio.png`

    const [imgSrc, setImgSrc] = useState<string>(
        src || (isMerchantImage ? merchantDefaultImage : productNotFoundImage)
    )

    const handleError = () => {
        const currentDefaultImage = isMerchantImage ? merchantDefaultImage : productNotFoundImage
        setImgSrc(fallbackSrc ?? currentDefaultImage)
    }

    useEffect(() => {
        setImgSrc(src || (isMerchantImage ? merchantDefaultImage : productNotFoundImage))
    }, [src, isMerchantImage])

    if (imgSrc && imgSrc?.includes("undefined")) {
        setImgSrc((isMerchantImage ? merchantDefaultImage : productNotFoundImage))
    }

    return (
        // TODO: Tentar otimizar imagens com Image.
        <img
            draggable={false}
            src={imgSrc}
            alt={alt}
            onError={handleError}
            className={className}
            style={style}
        />
    )
}

export default ImageFallback